import * as React from "react"

const TripManagement = (props) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 3.375v1.5H3v10.5h18v-2.25h1.5v3a.75.75 0 0 1-.648.743l-.102.007h-1.483v3.75h-1.5v-3.75h-5.822a2.25 2.25 0 1 1-3.355 0H6.945a2.25 2.25 0 1 1-3.355 0H2.25a.75.75 0 0 1-.743-.648l-.007-.102v-12a.75.75 0 0 1 .648-.743l.102-.007H13.5Zm-8.233 14.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm6 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM19.21 3.532l.07.063 3 3a.75.75 0 0 1 .063.99l-.063.07-3 3a.75.75 0 0 1-1.123-.99l.063-.07 1.719-1.72H15.75a.75.75 0 0 1-.088-1.495l.088-.005h4.189l-1.72-1.72a.75.75 0 0 1-.062-.99l.063-.07a.75.75 0 0 1 .99-.063Z"
      fill="#80B8EE"
    />
  </svg>
)

export default TripManagement;